import { useEffect } from "react";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { useLoader } from "../context/LoaderContext";

const Preloader = () => {
  const { loading } = useLoader();
  const { companyDetailsData } = useCompanyDetailsContext();

  useEffect(() => {
    if (companyDetailsData[0]?.company_name) {
      document.title = companyDetailsData[0].company_name;
    }

    if (!companyDetailsData[0]?.favicon_color) return;

    let link = document.querySelector("link[rel~='icon']");

    if (link instanceof HTMLLinkElement) {
      link.href = `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.favicon_color[0]?.media?.url}`;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.favicon_color[0]?.media?.url}`;
      document.head.appendChild(newLink);
    }
  }, [companyDetailsData]);

  return (
    <>
      {loading ? (
        <div className="loader-mask">
          <div className="preloader">
            {companyDetailsData.length > 0 ? (
              <img
                src={
                  companyDetailsData[0]?.primary_logo_color[0]?.media?.url &&
                  `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color[0]?.media?.url}`
                }
                alt="Logo"
                className="preloader-logo"
              />
            ) : (
              <div className="static-loader"></div>
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Preloader;
